import React, { useState } from "react";
import { formatNumber } from "../../Helper/Helper";
import arr from "../../img/arrow-down.png";
import { newDates } from "../../Helper/bigTableDates";
import "./Table.scss";

export default function BigTable({ firstThName, tableTitle, data, showBtn }) {
  const [expand, setExpand] = useState(false);

  return (
    <div className="NbpPricesTable">
      <h3
        className={
          tableTitle === "none" ? "text-center displayNone" : "text-center"
        }
      >
        {tableTitle}
      </h3>

      <div
        className={
          showBtn === "none"
            ? "table-container table-full-size"
            : expand === false
            ? "table-container table-half-size"
            : "table-container table-full-size"
        }
      >
        <table className="total-table total-table-stripped table-sm">
          <thead>
            <tr>
              <th>{firstThName}</th>
              {newDates?.map((item, index) => (
                <th key={index}>{item}</th>
              ))}
              <th>Daily % </th>
              <th>Weekly %</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((row, index) => {
              return (
                <tr key={index}>
                  {index === 0 ? (
                    <td>{firstThName === "NL Power" ? "Spot Base" : "Spot"}</td>
                  ) : index === 1 ? (
                    <td>Spot Peak </td>
                  ) : (
                    <td>Spot OffPeak </td>
                  )}
                  <td>{formatNumber(row.col2)}</td>
                  <td>{formatNumber(row.col3)}</td>
                  <td>{formatNumber(row.col4)}</td>
                  <td>{formatNumber(row.col5)}</td>
                  <td>{formatNumber(row.col6)}</td>
                  <td>{formatNumber(row.col7)}</td>
                  <td>{formatNumber(row.col8)}</td>
                  <td style={{ color: `${row.col9 < 0 ? "green" : "red"}` }}>
                    {formatNumber(row.col9)}%
                  </td>
                  <td style={{ color: `${row.col10 < 0 ? "green" : "red"}` }}>
                    {formatNumber(row.col10)}%
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div
        className={
          showBtn === "none"
            ? "exp-btn text-end displayNone"
            : "exp-btn text-end"
        }
      >
        <button
          onClick={() => setExpand(!expand)}
          type="button"
          className="expand btn"
        >
          Expand&nbsp;
          <img src={arr} alt="expand" />
        </button>
      </div>
    </div>
  );
}
